import { getImageUrl } from '../../domain/utils/image'
import { JO_CELEBRATION_PLACE, JO_EVENT_SITE } from '../geoentity/geoentity.constants'

export default function (response) {
  return {
    suggests: response.suggests.map((suggest = {}) => {
      const { type, lat, lng, subtype, labels, brand_icon_url, icon_urls, address_components } = suggest

      const iconUrls = icon_urls
        ? {
            iconUrls: icon_urls.map(iconUrl => getImageUrl(iconUrl))
          }
        : {}

      const brandIconUrl = brand_icon_url ? { brandIconUrl: getImageUrl(brand_icon_url) } : {}

      return Object.assign(
        {},
        { type, lat, lng, labels },
        subtype ? { subtype } : {},
        subtype?.id === JO_EVENT_SITE || subtype?.id === JO_CELEBRATION_PLACE ? { address_components } : {},
        iconUrls,
        brandIconUrl
      )
    })
  }
}
